// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".opr{width:40px;font-size:12px;color:#35b9ff;cursor:pointer}.dq,.opr{line-height:20px}.gs{width:140px;text-align:right}.name{text-overflow:ellipsis;overflow:hidden}", ""]);
// Exports
module.exports = exports;
